@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.summary {
  display: flex;
  gap: 10px;
  padding: 10px 5px;
  border-radius: 6px;
  background: var(--light-100);

  @include container-shadow;
  @include blur(35px);

  @include for-phone-only {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    padding: 0;
    position: relative;

    // Create grid lines
    &::before,
    &::after {
      content: '';
      position: absolute;
      background-color: var(--dark-4);
    }

    // Vertical line
    &::before {
      width: 1px;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    }

    // Horizontal line
    &::after {
      width: 100%;
      height: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.skeleton {
  :global .ant-skeleton-title {
    height: 25px;
    margin: 8px 0;
  }
}

.divider {
  width: 1px;
  height: 82px;
  margin: 0 10px;
  background-color: var(--dark-4);

  @include for-phone-only {
    display: none;
  }
}

.summaryItem {
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;

  @include for-phone-only {
    border-radius: 0;
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    .details {
      display: flex;
      flex-direction: column;

      .valueAndChange {
        display: flex;
        gap: 5px;

        .value {
          @include xxxl-sohne;

          @include for-phone-only {
            @include xl-sohne;
          }
        }

        .change {
          @include lg-sohne;
          color: rgba(0, 0, 0, 0.15);

          &.positive {
            color: var(--green-50);
          }

          &.negative {
            color: var(--red-50);
          }
        }
      }
    }
  }
}
